import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './vehicleTypeModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Vehicle/CreateEdit';

function VehicleTypeCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          vehichleTypeEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default VehicleTypeCreateModal;
